export type TemplateTier = "free" | "pro";

export interface TemplateMeta {
  id: string;
  nameKey: string;
  descriptionKey: string;
  tier: TemplateTier;
  accent: string;
  fontPair: "sans" | "serif" | "mono" | "mixed";
  density: "comfortable" | "compact";
}

export const TEMPLATES = [
  {
    id: "classic",
    nameKey: "templates.classic.name",
    descriptionKey: "templates.classic.description",
    tier: "free",
    accent: "#1d1d1f",
    fontPair: "serif",
    density: "comfortable",
  },
  {
    id: "minimal",
    nameKey: "templates.minimal.name",
    descriptionKey: "templates.minimal.description",
    tier: "free",
    accent: "#0071e3",
    fontPair: "sans",
    density: "comfortable",
  },
  {
    id: "mono",
    nameKey: "templates.mono.name",
    descriptionKey: "templates.mono.description",
    tier: "free",
    accent: "#1d1d1f",
    fontPair: "mono",
    density: "compact",
  },
  {
    id: "editorial",
    nameKey: "templates.editorial.name",
    descriptionKey: "templates.editorial.description",
    tier: "free",
    accent: "#8a1c1c",
    fontPair: "serif",
    density: "comfortable",
  },
  {
    id: "sidebar",
    nameKey: "templates.sidebar.name",
    descriptionKey: "templates.sidebar.description",
    tier: "free",
    accent: "#1f5c4a",
    fontPair: "sans",
    density: "compact",
  },
  {
    id: "timeline",
    nameKey: "templates.timeline.name",
    descriptionKey: "templates.timeline.description",
    tier: "pro",
    accent: "#0071e3",
    fontPair: "sans",
    density: "comfortable",
  },
  {
    id: "compact",
    nameKey: "templates.compact.name",
    descriptionKey: "templates.compact.description",
    tier: "pro",
    accent: "#1d1d1f",
    fontPair: "sans",
    density: "compact",
  },
  {
    id: "bold",
    nameKey: "templates.bold.name",
    descriptionKey: "templates.bold.description",
    tier: "pro",
    accent: "#d70015",
    fontPair: "mixed",
    density: "comfortable",
  },
] as const satisfies readonly TemplateMeta[];

export const FREE_TEMPLATE_IDS = TEMPLATES.filter((t) => t.tier === "free").map((t) => t.id);

export function getTemplate(id: string): TemplateMeta | undefined {
  return TEMPLATES.find((t) => t.id === id);
}

export function isPremiumTemplate(id: string): boolean {
  return getTemplate(id)?.tier === "pro";
}
